import { Component, OnInit } from '@angular/core';

declare var $:any;

@Component({
  selector: 'app-view-shop',
  templateUrl: './view-shop.component.html',
  styleUrls: ['./view-shop.component.css']
})
export class ViewShopComponent implements OnInit {

  pageName = "My Shop Details";

  constructor() { }

  ngOnInit() {

  	$('#initialise-page').trigger('click');
  }

}
